/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
document.querySelectorAll(".open_hero_herre_cstm").forEach(item => {
  item.addEventListener("click",function(event){
    event.preventDefault()
    document.querySelector(".cstm_title_nav").click();
    setTimeout(function(){
      document.querySelector(".cstm_flink_herre").click();
    },500)
  })
});
  
document.querySelectorAll(".open_hero_damm_cstm").forEach(items => {
  items.addEventListener("click",function(event){
    event.preventDefault()
    document.querySelector(".cstm_title_nav").click();
    setTimeout(function(){
      document.querySelector(".cstm_flink_dame").click();
    },500)
  })
});

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
